import React, { useEffect, useState, useContext } from 'react';
import { Container } from 'reactstrap';
import styles from './CoverageDocsCostco.module.css';
import { getTranslation } from '../../../helpers';
import { LanguageContext } from '../../../components/contexts/LanguageTranslation/LanguageContext';

const costcoCoverage = [
    {
        language: 'Français',
        content: {
            costcoIosCoverage: [
                { name: 'Conditions Générales iOS', fileName: 'costco_fr_terms_and_condition_ios' },
                { name: 'Fiche de Renseignements iOS', fileName: 'costco_fr_fact_product_summary_ios' },
                { name: ' Sommaire Du Produit iOS', fileName: 'costco_fr_fact_product_summary_ios' }
            ],
            costcoNonIosCoverage: [
                { name: ' Conditions Générales Non-iOS', fileName: 'costco_fr_terms_and_condition_nonios' },
                { name: 'Fiche de Renseignements Non-iOS', fileName: 'costco_fr_fact_product_summary_nonios' },
                { name: ' Sommaire Du Produit Non-iOS', fileName: 'costco_fr_fact_product_summary_nonios' }
            ]
        }
    },
    {
        language: 'English',
        content: {
            costcoIosCoverage: [
                { name: 'iOS Terms and Conditions', fileName: 'costco_eng_terms_and_condition_ios' },
                { name: 'iOS Fact Sheet', fileName: 'costco_eng_fact_product_summary_ios' },
                { name: 'iOS Product Summary', fileName: 'costco_eng_fact_product_summary_ios' }
            ],
            costcoNonIosCoverage: [
                { name: 'Non-iOS Terms and Conditions', fileName: 'costco_eng_terms_and_condition_nonios' },
                { name: 'Non-iOS Fact Sheet', fileName: 'costco_eng_fact_product_summary_nonios' },
                { name: 'Non-iOS Product Summary', fileName: 'costco_eng_fact_product_summary_nonios' }
            ]
        }
    }
];

export const CoverageDocsCostco = () => {
    const [translationData, setTranslationData] = useState({});
    const languageContext = useContext(LanguageContext);

    useEffect(() => {
        const language = languageContext.language?.toUpperCase();
        if (language !== 'EN') {
            const fullPath = `Customer/${language}/screens/Vendor/Apple/CoverageDocsCostco.json`;

            getTranslation(fullPath)
                .then((response) => response.json())
                .then((data) => {
                    setTranslationData(data);
                })
                .catch((error) => {
                    console.error(error);
                });
        } else {
            setTranslationData({});
        }
    }, [languageContext.language]);

    const handleViewDocument = (e, fileName) => {
        e.preventDefault();
        fetch(`api/document/GetDynamicDocument/2/1/${fileName}.pdf/apple`)
            .then((res) => res.blob())
            .then((blob) => {
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.target = '_blank';
                link.click();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const CostcoPdfComponent = ({ details }) => {
        return (
            <p>
                <a
                    href='#'
                    onClick={(e) => handleViewDocument(e, details.fileName)}
                >
                    {details.name}
                </a>
            </p>
        );
    };

    return (
        <>
            <div className={styles.costcoTitle}>
                <Container>
                    <h1 className='h2'>{translationData?.Heading || 'AppleCare+ Coverage Documents for Costco'}</h1>
                    <p className='m-0'>
                        {translationData?.Subheading || 'Select a document to view the terms and conditions.'}
                    </p>
                </Container>
            </div>

            <Container className={`${styles.costcoWrapper} d-flex flex-column align-items-center`}>
                {costcoCoverage.map((data, index) => {
                    return (
                        <div className={data.language === 'English' ? styles.costcoCoverageSection : ''}>
                            <h6 className={styles.costcoCoverageHeader}>{data.language}</h6>
                            <div className={`${styles.costcoCoverageWrapper} d-flex`}>
                                {Object.keys(data.content).map((key) => {
                                    return (
                                        <div
                                            className={`${key === 'costcoIosCoverage' ? styles.costcoIosWrapper : styles.costcoNonIosWrapper} text-left`}
                                        >
                                            {data.content[key].map((details) => {
                                                return <CostcoPdfComponent details={details} />;
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </Container>
        </>
    );
};
